import streamUpload3 from "./streamUpload3";
import finishUpload3 from "./finishUpload3";
import removeUpload3 from "./removeUpload3";
import initUpload3 from "./initUpload3";
import pub3Confirm from "./pub3Confirm";
import download3 from "./download3";

const data3 = {
  initUpload3,
  streamUpload3,
  finishUpload3,
  removeUpload3,
  pub3Confirm,
  download3,
};

export default data3;
